import { OnInit } from '@angular/core';
import { Account } from './account';
import { Role } from './role';

export class User {
  user_id: number;
  user_email: string;
  first_name: string;
  last_name: string;
  mobile_number: string;
  ddi_number: string;
  skype_id: string;
  linkedin: string;
  status: number;
  logged_in_before: number;
  account: Account;
  user_roles: Role[];
  created_on: string;

  constructor() {
    this.account = new Account();
    this.user_roles = new Array<Role>();
  }
}




// WEBPACK FOOTER //
// ./src/app/user/user.ts